interface EventListener<TSender, TArgs> {
    (args: TArgs, sender: TSender): void;
}

export interface Event<TSender, TArgs> {
    subscribe(listener: EventListener<TSender, TArgs>): void;
    unsubscribe(listener: EventListener<TSender, TArgs>): void;
}

export class EventDispatcher<TSender, TArgs> implements Event<TSender, TArgs> {
    private listeners = new Set<EventListener<TSender, TArgs>>();

    subscribe(listener: EventListener<TSender, TArgs>) {
        this.listeners.add(listener);
    }

    unsubscribe(listener: EventListener<TSender, TArgs>) {
        this.listeners.delete(listener);
    }

    subscribeOnce(listener: EventListener<TSender, TArgs>) {
        let wrapper = (args: TArgs, sender: TSender) => {
            listener(args, sender);
            this.unsubscribe(wrapper);
            wrapper = void 0;
        };
        this.subscribe(wrapper);
    }

    dispatch(sender: TSender, args: TArgs) {
        this.listeners.forEach(listener => listener(args, sender));
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/event.ts
 **/